<template>
  <div class="singleerr">
    <div class="list_box"
         v-for="(item,index) in group"
         :key="index">
      <div class="_row">
        <div class="strIcon">{{  setNumberToLetter(index+1) }}</div>
        <div>
          <form_select v-model="item.theme"
                       ref="form"
                       :options="eventOptions"
                       @change="()=>{
                        item.attrsList = eventOptions.filter(_item=>  _item.value==item.theme )[0].chidlren
                        item.service_typeOptions = item.attrsList.filter(_item => _item.label=='service_type' )[0].children
                        item.service_numberOptions = item.attrsList.filter(_item => _item.value=='service_number' )[0].children
                        // item.attrs[0].val = []
                        // item.attrs[1].val = []
                        item.attrs.forEach((_item,_index)=>{
                          _item.val = []
                          if(_index >1){
                            _item.attr = ''
                          }
                        })
                      }"
                       placeholder="请选择事件表"
                       class="select" />
        </div>
        <div>
          <form_select v-model="item.attrs[0].val"
                       :disabled="item.theme==''"
                       ref="form"
                       :multiple="true"
                       :isRules="false"
                       :options="item.service_typeOptions || []"
                       placeholder="请选择service_type"
                       class="select" />
        </div>
        <div>
          <form_select v-model="item.attrs[1].val"
                       :disabled="item.theme==''"
                       ref="form"
                       :multiple="true"
                       :isRules="false"
                       :options="item.service_numberOptions || []"
                       placeholder="请选择service_number"
                       class="select"
                       style="width: 300px;" />
        </div>

        <div style="display: inline-block;">

          <el-tooltip content="添加条件"
                      placement="top">
            <el-button type="text"
                       @click="item.attrs.push({//属性行
              attr: '',
              valid: '',
              opt: '',
              val: [],// 多选
            })"
                       style="margin-left: 12px;"
                       icon="el-icon-zoom-in"></el-button> </el-tooltip>

          <el-tooltip content="删除"
                      v-if="index !=0"
                      placement="top">
            <el-button type="text"
                       @click="deleteRow(group,index)"
                       style="margin-left: 12px;"
                       icon="el-icon-delete"></el-button>
          </el-tooltip>
          <el-button type="primary"
                     @click="group.push({
          name: 'A',
          theme: '', //事件表
          attr_logic: 'AND',
          attrs: [
            { // service_type
              attr: 'service_type',
              opt: 'in',
              val: [] // 多选
            },
            {//service_number
              attr: 'service_number',
              opt: 'in',
              val: []// 多选
            },
            {//属性行
              attr: '',
              valid: '',
              opt: '',
              val: [],// 多选
            }
          ]
        })"
                     size="mini">添加事件</el-button>
        </div>

      </div>
      <div class="_row_item">
        <div class="andOrIcon"
             @click="()=>{ item.attr_logic = item.attr_logic=='AND'? 'OR' : 'AND' }">{{ item.attr_logic }}
        </div>
        <div class="_row_item_box">
          <div class="_row_box"
               v-for="(attrsItem, attrsIndex) in [...item.attrs.slice(2)]"
               :key="attrsIndex">
            <div>
              <form_select v-model="item.attrs[2+attrsIndex].attr"
                           :disabled="item.theme==''"
                           ref="form"
                           :options="item.attrsList || []"
                           placeholder="请输入属性"
                           @change="()=>{
                            item.attrs[2+attrsIndex].valid=''
                            item.attrs[2+attrsIndex].val = []
                            item.attrs[2+attrsIndex].valOptions = item.attrsList.filter(_item=>  _item.value==item.attrs[2+attrsIndex].attr )[0].children
                          }"
                           class="select" />
            </div>
            <div>
              <form_select v-model="item.attrs[2+attrsIndex].valid"
                           :disabled="item.attrs[2+attrsIndex].attr==''"
                           ref="form"
                           :options="validOptions || []"
                           @change="()=>{
                           let obj =  validOptions.filter(_item=>_item.value==item.attrs[2+attrsIndex].valid )[0] || {}
                           item.attrs[2+attrsIndex].val = []
                           if(obj.children){
                            item.attrs[2+attrsIndex].valOptions =obj.children
                          }else{
                            item.attrs[2+attrsIndex].valOptions = item.attrsList.filter(_item=>  _item.value==item.attrs[2+attrsIndex].attr )[0].children
                          }
                          }"
                           placeholder="请选择口径"
                           class="select" />
            </div>
            <div>
              <form_select v-model="item.attrs[2+attrsIndex].opt"
                           ref="form"
                           :options="optOptions || []"
                           placeholder="请选择判断"
                           class="select" />
            </div>
            <!-- 如果是非空为空就不显示 -->
            <div v-if="item.attrs[2+attrsIndex].opt != '非空' && item.attrs[2+attrsIndex].opt != '为空'">
              <form_select v-model="item.attrs[2+attrsIndex].val"
                           :disabled="item.attrs[2+attrsIndex].attr==''"
                           ref="form"
                           :multiple="true"
                           :options="item.attrs[2+attrsIndex].valOptions || []"
                           placeholder="请输入结果"
                           class="select" />
            </div>
            <div>
              <el-tooltip content="删除"
                          placement="top">
                <el-button type="text"
                           @click="deleteRow(group[index].attrs ,attrsIndex + 2)"
                           style="margin-left: 12px;"
                           icon="el-icon-delete"></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import form_select from '../../userClustering/components_form/form_select.vue'
import { qual_get_general_attr, qual_get_valid, qual_get_opt } from '@/api/bigData'

export default {
  components: {
    form_select
  },
  name: 'singleerr',
  data () {
    return {
      group: [
        {
          name: 'A',
          theme: '', //事件表
          attr_logic: 'AND',
          attrs: [
            { // service_type
              attr: 'service_type',
              opt: 'in',
              val: [] // 多选
            },
            {//service_number
              attr: 'service_number',
              opt: 'in',
              val: []// 多选
            },
            {//属性行
              attr: '',
              valid: '',
              opt: '',
              val: [],// 多选
            }
          ]
        }
      ],
      eventOptions: [], // 事件下拉选项
      validOptions: [], // 校验口径
      optOptions: [], // 运算符
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 校验页面
    validateDom (callback) {
      let isList = []
      let domList = this.$refs['form'] || []
      domList.forEach(item => {
        item.itemValidate((res) => {
          console.log('callback--', res)
          isList.push(res)
        })
      })
      let is = isList.every(item => item === true)
      callback(is)
    },

    // 触发回显数据
    triggerEcho () {
      this.$nextTick(() => {
        let domList = this.$refs['form'] || []
        domList.forEach(item => {
          item && item.change()
        })
      })
    },

    // 删除行
    deleteRow (row, index) {
      row.splice(index, 1);
    },
    // 数组下标转字母
    setNumberToLetter (i) {
      let data = this.numberToLetter(i)
      this.group[i - 1].name = data
      return data
    },
    numberToLetter (number) {
      if (number < 1 || number > 999) {
        return "nall~";
      }
      const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (number <= 26) {
        return letters.charAt(number - 1);
      } else if (number <= 676) {
        const firstLetter = letters.charAt(Math.floor((number - 1) / 26) - 1);
        const secondLetter = letters.charAt((number - 1) % 26);
        return firstLetter + secondLetter;
      } else {
        const firstLetter = letters.charAt(Math.floor((number - 1) / 676) - 1);
        const secondLetter = letters.charAt(Math.floor(((number - 1) % 676) / 26));
        const thirdLetter = letters.charAt((number - 1) % 26);
        return firstLetter + secondLetter + thirdLetter;
      }
    },

    init () {
      // 通用属性筛选
      qual_get_general_attr().then(res => {
        if (res.status == 200) {
          this.eventOptions = res.data
          this.triggerEcho()
        }
        console.log('qual_get_general_attr通用属性筛选', res)
      })
      // 校验口径
      qual_get_valid().then(res => {
        if (res.status == 200) {
          this.validOptions = res.data
        }
        console.log('qual_get_general_attr校验口径', res)
      })
      // 运算符
      qual_get_opt().then(res => {
        if (res.status == 200) {
          this.optOptions = res.data
        }
        console.log('qual_get_general_attr运算符', res)
      })

    }
  }

}
</script>

<style lang="scss" scoped>
.singleerr {
  box-sizing: border-box;
  .list_box {
    margin-top: 20px;
    margin-bottom: 55px;
  }
  .select {
    display: inline-block;
    margin-right: 10px;
  }
  ._row {
    display: flex;
  }
  .strIcon {
    height: 38px;
    width: 40px;
    line-height: 38px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px 0 0 5px;
    background-color: #f4f6f8;
  }
  ._row_item {
    display: flex;
    align-items: center;
    border-left: 2px solid #ccc;
    border-radius: 0 0 0 10px;
    min-width: 1650px;
    margin-left: 80px;
    margin-top: -20px;
  }
  .andOrIcon {
    cursor: pointer;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    padding: 5px 10px;
    color: #5b93fc;
    border: 1px solid #ccc;
    border-radius: 12px;
    width: 50px;
    text-align: center;
    margin-left: -36px;
    background-color: #fff;
  }
  ._row_box {
    display: flex;
    height: 20px;
    margin-top: 30px;
  }
  ._row_item_box {
    box-sizing: border-box;
    padding-left: 10px;
  }
}
</style>